import { createContext, useContext, useEffect, useState } from 'react';
import { onSnapshot, doc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { db } from '../../Firebase/firebase_init';
import { testData, testDataIRL } from '../../Pages/ResultPage/testData';
import getResultData, { isResultSamplePage } from './getResultData';

const ResultContext = createContext(null);

const isLocalhost = () => {
    const { hostname } = window.location;
    const isLocalhost = hostname.includes("localhost") || hostname.includes("192.168.0.100");

    return Boolean(isLocalhost);
}

const sample_data = isLocalhost() ? testData : testDataIRL;


export const ResultDataProvider = ({ children }) => {
    const [notFound, setNotFound] = useState(false);
    const [data, setData] = useState(null);
    const { id } = useParams();
    const { results, ...rest } = data || {};
    const additional_data = getResultData(results);
    useEffect(() => {
        if (isResultSamplePage()) {
            setData({ ...sample_data, test_page: true });
            return;
        }
        if (!id) return;

        const unsubscribe = onSnapshot(doc(db, 'result', id), (snapshot) => {
            if (snapshot?.exists()) {
                const webData = snapshot.data();
                console.log("Result data loaded", id);
                console.log("webData", webData);

                setNotFound(false);
                setData(webData);


            } else {
                setNotFound(true);
                setData(null);
            }
        });
        return () => unsubscribe();
    }, [id]);

    return (
        <ResultContext.Provider value={{
            data: results, // Result data
            notFound,
            ...rest,
            ...additional_data,
            orderId: id,
        }}>
            {children}
        </ResultContext.Provider>
    );
};

export const useResult = () => useContext(ResultContext);
